<!-- <div class="carouselWrapper">
  <carousel
  [cellsToShow]="cellsToShow"
  [objectFit]="size"
  [autoplayInterval]="2000"
  [loop]="true"
  [autoplay]="true"
[images]="images"

  >


</carousel>
</div> -->
 <!-- <ng-container *ngFor="let x of images">
    <img style="object-fit: cover;" src="{{x.path}}" alt="{{x.alt}}">

  </ng-container> -->

<!-- <div class="carousel-container">
  <div class="carousel-inner">
 <div class="track">
    <div *ngFor="let x of images" class="card-container">
      <div class="card">
        <div  class="img">
<img src="{{x.path}}" alt="{{x.alt}}">
        </div>

      </div>
    </div>

  </div>
    <div class="nav">
    <button class="prev">prev</button>
    <button class="next">next</button>
  </div>
  </div>

</div> -->
<!-- <div class="ourClientsCarouselHeading">
  <h2>Our Clients</h2>
</div> -->

<div class="slider">
  <div role="img" aria-label="MLB logo" class="slide current">
    <!-- <div class="content">
      <p>Slide One</p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sit hic
        maxime, voluptatibus labore doloremque vero!
      </p>
    </div> -->
  </div>
  <div  role="img" aria-label="MLS logo"  class="slide">
    <!-- <div class="content">
      <p>Slide Two</p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sit hic
        maxime, voluptatibus labore doloremque vero!
      </p>
    </div> -->
  </div>
  <div  role="img" aria-label="NASCAR logo"  class="slide">
    <!-- <div class="content">
      <p>Slide 3</p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sit hic
        maxime, voluptatibus labore doloremque vero!
      </p>
    </div> -->
  </div>

  <div  role="img" aria-label="NCAA logo" class="slide">
    <!-- <div class="content">
      <p>Slide 4</p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sit hic
        maxime, voluptatibus labore doloremque vero!
      </p>
    </div> -->
  </div>
  <div  role="img" aria-label="NFL logo" class="slide">
    <!-- <div class="content">
      <p>Slide 5</p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sit hic
        maxime, voluptatibus labore doloremque vero!
      </p>
    </div> -->
  </div>
  <div  role="img" aria-label="NHL logo" class="slide">
    <!-- <div class="content">
      <p>Slide 6</p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sit hic
        maxime, voluptatibus labore doloremque vero!
      </p>
    </div> -->
  </div>
  <div  role="img" aria-label="PGA logo"  class="slide">
    <!-- <div class="content">
      <p>Slide 7</p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sit hic
        maxime, voluptatibus labore doloremque vero!
      </p>
    </div> -->
  </div>
  <div  role="img" aria-label="Rose Bowl logo" class="slide">
    <!-- <div class="content">
      <p>Slide 8</p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sit hic
        maxime, voluptatibus labore doloremque vero!
      </p>
    </div> -->
  </div>
  <div  role="img" aria-label="SoFi Stadium logo" class="slide">
    <!-- <div class="content">
      <p>Slide 9</p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sit hic
        maxime, voluptatibus labore doloremque vero!
      </p>
    </div> -->
  </div>
  <div  role="img" aria-label="NBA logo" class="slide">
    <!-- <div class="content">
      <p>Slide 9</p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sit hic
        maxime, voluptatibus labore doloremque vero!
      </p>
    </div> -->
  </div>
  <div class="buttons">
    <button id="prev"><span class="material-icons">
      chevron_left
      </span></button>
    <button id="next"><span class="material-icons">
      navigate_next
      </span></button>
  </div>
</div>
